import { Route } from 'react-router-dom';
import Notificaciones from './Notificaciones';
import CreateNotificacion from './Create-notificacion';
import ListarNotificacionesComponente from './Listar-notificaciones';
import ListarNotificacionesUsuarioComponente from './Listar-notificaciones-usuario';

const NotificacionesRouter = (
  <Route path="notificaciones" element={<Notificaciones />}>
    <Route path="" element={<ListarNotificacionesComponente />} />
    <Route path="nueva" element={<CreateNotificacion />} />
    <Route path="lectura" element={<ListarNotificacionesUsuarioComponente />} />
  </Route>
);

export default NotificacionesRouter;
